import UserInfoType from './userInfo.types';

export const addUserStart = usersData => ({
    type: UserInfoType.ADD_USER_INFO,
    payload: usersData
  });
  
export const fetchUsersStart = () => ({
    type: UserInfoType.FETCH_USER_INFO
  });

  export const setUserInfo = usersInfos => ({
    type: UserInfoType.SET_USER,
    payload: usersInfos
  });

  export const fetchUserStart = productAdminUserUID => ({
    type: UserInfoType.FETCH_USERPAGE_INFO,
    payload: productAdminUserUID
  });

  export const setUserInfoPage = userInfo => ({
    type: UserInfoType.FETCH_USER_INFO_PAGE,
    payload: userInfo
  });